import React, { useState } from 'react';

function Thumbnail({ src, onClick, className }) {
  const [isLoading, setIsLoading] = useState(true);
  return (
    <div>
      <p className={`${!isLoading && 'hidden'}`}>Cargando...</p>
      <img
        className={`${isLoading && 'hidden'} ${className}`}
        onClick={onClick}
        src={src}
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
}

export default Thumbnail;
